import React from 'react';
import API from 'fw/system/API';
import * as APIModules from 'modules/app/API';
import { Link } from 'fw/components/formatter/Formatter';
import * as App from 'modules/app/App';

class BusinessTypesTotalLink extends React.Component {
	handleClick = (e) => {
		e.stopPropagation();
		return false;
	}

	shouldComponentUpdate(nextProps) {
		return nextProps.value !== this.props.value;
	}

	onExportData = () => {
		const rq = {
			isSDVob: false,
			statusCode: "Total VOB/SDVOB"
		};

		if (App.hasPrivilege("ExecutiveReportSummarySearch")) {
			new API().post(APIModules.Admin.url('/dashboard/getBusinessTypesExport', rq), rq,
				{
					success: (sr) => {
						new API().download(sr.data);
					}
				});
		}
	}

	_getPreQualificationSearchQueueLinkValue() {
		return {
			url: `/admin/searchQueue?showAll=true&certificationStatusCode=PRE_STR`,
			title: this.props.value
		};
	}

	_getApplicationsSearchQueueLinkValue() {
		return {
			url: `/admin/searchQueue?showAll=true&certificationStatusCode=APL`,
			title: this.props.value
		};
	}

	_getConnectVOBLinkValue(statusCode) {
		return {
			url: `/admin/connectToVOB?certificationStatusCode=${statusCode}`,
			title: this.props.value
		};
	}

	render() {
		const row = this.props.dependentValues;
		const centerAlignStyle = { display: "block", textAlign: "center" };
		const value = this.props.value ? this.props.value : 0;
		const isZero = value === 0 || value === "0";

		// Prequals row - link to search queue with background
		if (row.certificationStatusDescription === "Prequals") {
			return (
				<div style={{ backgroundColor: "#f0f0f0", marginLeft: "-8px", marginRight: "-8px", height: "35px", lineHeight: "35px", paddingRight: "8px" }}>
					{isZero ? (
						<span style={centerAlignStyle}>{value}</span>
					) : (
						<Link value={this._getPreQualificationSearchQueueLinkValue()} style={centerAlignStyle}></Link>
					)}
				</div>
			);
		}

		// TOTAL SD/VOB row - export link with background
		if (row.certificationStatusDescription === "TOTAL SD/VOB") {
			return (
				<div style={{ backgroundColor: "#e0e0e0", marginLeft: "-8px", marginRight: "-8px", height: "35px", lineHeight: "35px", paddingRight: "8px" }}>
					<a onClick={this.onExportData} style={{ ...centerAlignStyle, color: "#3c8dbc", cursor: "pointer" }}>{this.props.value}</a>
				</div>
			);
		}

		// TOTALS row - plain text (sum of all statuses, no meaningful filter)
		if (row.certificationStatusDescription === "TOTALS") {
			return (
				<span style={centerAlignStyle}>{value}</span>
			);
		}

		// Decertified - plain text (no link available)
		if (row.certificationStatusDescription === "Decertified") {
			return (
				<span style={centerAlignStyle}>{value}</span>
			);
		}

		// Applications - link to search queue
		if (row.certificationStatusDescription === "Applications") {
			if (isZero) {
				return (
					<span style={centerAlignStyle}>{value}</span>
				);
			}
			return (
				<Link value={this._getApplicationsSearchQueueLinkValue()} style={centerAlignStyle}></Link>
			);
		}

		// Certified - link to connectToVOB
		if (row.certificationStatusDescription === "Certified") {
			if (isZero) {
				return (
					<span style={centerAlignStyle}>{value}</span>
				);
			}
			return (
				<Link value={this._getConnectVOBLinkValue("CER")} style={centerAlignStyle}></Link>
			);
		}

		// Expired - link to connectToVOB
		if (row.certificationStatusDescription === "Expired") {
			if (isZero) {
				return (
					<span style={centerAlignStyle}>{value}</span>
				);
			}
			return (
				<Link value={this._getConnectVOBLinkValue("EXP")} style={centerAlignStyle}></Link>
			);
		}

		// Default - plain text
		return (
			<span style={centerAlignStyle}>{value}</span>
		);
	}
}

export default BusinessTypesTotalLink;



// WEBPACK FOOTER //
// ./src/areas/shared/components/formatter/BusinessTypesTotalLink.js